package com.appcreator.client.revenuecat

actual fun revenueCatInitialize(androidApiKey: String, iOSApiKey: String) {
    console.log("Revenue Cat is not yet support on web")
}
